import GenericOrdersListing from "@Pages/OrderListing/GenericOrdersListing.js";
import ChatPopup from "@Pages/GenericOrderChat/ChatPopup.jsx";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";

function AllReleasedOrdersListing() {
  return (
    <GenericOrdersListing
      title="All Released Orders"
      isReleased={true}
      isCanceled={false}
      readOnly={true}
      icon={AssignmentTurnedInRoundedIcon}
      ChatPopup={ChatPopup}
      allOrders={true}
    />
  );
}

export default AllReleasedOrdersListing;
